import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { any } from '../../libs/utils';
import FeedbackModal from '../Modals/Feedback';

const HIDE_FOR_PATHS = [
  '/e/',
  '/eam'
]

const Feedback: React.FC = () => {
  const location = useLocation();
  const [modalShow, setModalShow] = useState<boolean>(false);

  const shouldHideFeedback = any(HIDE_FOR_PATHS, (p) => location.pathname.startsWith(p));

  return <>
    <div className='hidden lg:block fixed bottom-0 right-20'>
      <div className='inline-block h-5 text-hover text-xs pt-2 px-2 cursor-default'>
        <span>Powered By WhiteDog Cyber</span>
      </div>
      {!shouldHideFeedback && <div className='inline-block h-9 bg-nav text-nav-text pt-2 px-2 cursor-pointer select-none' onClick={() => setModalShow(true)}>
        <span><i className="bi bi-chat-left-fill" /> Feedback</span>
      </div>}
    </div>
    <FeedbackModal show={modalShow} close={() => setModalShow(false)} />
  </>;
};

export default Feedback;
